var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-100 rounded"},[_c('input',{staticClass:"bg-transparent w-full px-4 py-2",attrs:{"type":_vm.type,"name":_vm.name,"id":_vm.id || _vm.name,"placeholder":_vm.placeholder,"multiple":_vm.multiple,"autocomplete":_vm.autocomplete},domProps:{"value":_vm.value},on:{"change":_vm.handleChange,"input":_vm.handleInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }